export const form_view = {
  id: 'form_view',
  type: 'form',
  mode: 'view',
  visual: {
    showModifiedDate: true,
    showCreatedDate: false,
    showDelete: true,
  },
};

export const form_details = {
  id: 'form_details',
  type: 'form',
  mode: 'edit',
  visual: {
    showModifiedDate: true,
    showCreatedDate: false,
    showDelete: true,
  },
};

export const form_create = {
  id: 'form_create',
  type: 'form',
  mode: 'create',
  visual: {
    showModifiedDate: false,
    showCreatedDate: false,
    showDelete: false,
  },
};

export const form_defaults = {
  view: form_view,
  details: form_details,
  create: form_create,
};
